import { render, staticRenderFns } from "./FormCardProfileAssociante.vue?vue&type=template&id=19b09302"
import script from "./FormCardProfileAssociante.vue?vue&type=script&lang=js"
export * from "./FormCardProfileAssociante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports